import * as React from 'react';

export const SortingContext = React.createContext<SortContextProps>({});
